// ErrorBoundary.js - Last-resort catch for React render crashes.
// Reports the crash to the activity log and replaces the blank screen with a
// reload prompt so the user is never left staring at nothing.
import React from 'react';
import api from '../utils/api';
import THEME from '../styles/theme';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    const firstFrame = info && info.componentStack
      ? info.componentStack.split('\n').map(s => s.trim()).filter(Boolean)[0]
      : null;
    api.track('error', 'client_error', `React render: ${error.message} (${firstFrame || 'unknown component'})`);
  }

  render() {
    if (!this.state.error) {
      return this.props.children;
    }

    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: THEME.canvasBackground,
        color: THEME.textPrimary,
        fontFamily: 'system-ui, sans-serif',
        padding: '32px',
        textAlign: 'center'
      }}>
        <h2 style={{ color: THEME.accentPrimary, marginBottom: '8px' }}>Something went wrong</h2>
        <p style={{ color: THEME.textSecondary, maxWidth: '480px', lineHeight: 1.5 }}>
          GChain hit an unexpected error and has reported it. Reloading will bring back the
          last saved state of your project.
        </p>
        <button
          onClick={() => window.location.reload()}
          style={{
            marginTop: '16px',
            padding: '10px 24px',
            background: THEME.accentPrimary,
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            fontSize: '15px',
            fontWeight: 600,
            cursor: 'pointer'
          }}
        >
          Reload GChain
        </button>
        <pre style={{
          marginTop: '24px',
          color: THEME.textMuted,
          fontSize: '12px',
          whiteSpace: 'pre-wrap',
          maxWidth: '640px'
        }}>
          {String(this.state.error.message)}
        </pre>
      </div>
    );
  }
}

export default ErrorBoundary;
